import { useTranslation } from '@bcba/react-hooks';
import { DocumentSection } from '../../../../../shared/DocumentSection';
import { MultipleDocumentSection } from '../../../../../shared/MultipleDocumentSection';
import { ReadOnlyDocumentSection } from '../../../../../shared/ReadOnlyDocumentSection';
import { useCropPledgeDocumentationContext } from '../../context/CropPledgeDocumentationContext';

const FarmDataForm = () => {
  const { t } = useTranslation();
  const { data, isFormReadOnly } = useCropPledgeDocumentationContext();

  const { registeredPledgeFile, deregistrationOfPledgeFile } = data ?? {};

  return (
    <>
      <DocumentSection
        isDocumentRequired
        documentName="loanContractFile"
        label={t('cropPledge.documentationSection.form.loanContractFile.label')}
        hideDelete={isFormReadOnly}
        isReadonly={isFormReadOnly}
        expirationDateHelperText={t(
          'cropPledge.documentationSection.form.loanContractFile.expirationDateHelperText',
        )}
      />
      <ReadOnlyDocumentSection
        label={t(
          'cropPledge.documentationSection.form.carbonAnalysisFile.label',
        )}
        document={data?.carbonAnalysisFile?.document}
      />
      <ReadOnlyDocumentSection
        label={t('cropPledge.documentationSection.form.domainReportFile.label')}
        document={data?.domainReportFile?.document}
      />
      <ReadOnlyDocumentSection
        label={t(
          'cropPledge.documentationSection.form.modificationFormFile.label',
        )}
        document={data?.modificationFormFile?.document}
      />
      <MultipleDocumentSection
        name="additionalDocumentFiles"
        label={t(
          'cropPledge.documentationSection.form.additionalDocumentFiles.label',
        )}
        additionalLabel={t(
          'cropPledge.documentationSection.form.additionalDocumentFiles.add',
        )}
        hideDelete={isFormReadOnly}
        isReadonly={isFormReadOnly}
        helperText={t(
          'cropPledge.farmPropietaryData.form.aditionalDocumentation.helperText',
        )}
        defaultReadOnlyName={t('common.toBeUploadedByBolsa')}
      />
      {registeredPledgeFile?.document && (
        <ReadOnlyDocumentSection
          label={t('cropPledge.farmInfo.form.registeredPledgeFile.label')}
          document={registeredPledgeFile.document}
        />
      )}
      {deregistrationOfPledgeFile?.document && (
        <ReadOnlyDocumentSection
          label={t('cropPledge.farmInfo.form.deregistrationOfPledgeFile.label')}
          document={deregistrationOfPledgeFile.document}
        />
      )}
    </>
  );
};

export default FarmDataForm;
